export default {
    SET_LOADING_STATE: "holidays/SET_LOADING_STATE",
    SET_HOLIDAYS_LIST_DATA: "holidays/SET_HOLIDAYS_LIST_DATA",
    SET_DIALOG_STATE: "holidays/SET_DIALOG_STATE",
    SET_EDIT_FORM_DATA: "holidays/SET_EDIT_FORM_DATA",
    SET_HOLIDAY_DETAIL: "holidays/SET_HOLIDAY_DETAIL",
    SET_HOLIDAY_WORKERS: "holidays/SET_HOLIDAY_WORKERS",
    SET_HOLIDAY_WORKERS_PAYROLL_SUMMARY: "holidays/SET_HOLIDAY_WORKERS_PAYROLL_SUMMARY",
}
